import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicFooter from '../Footer/PublicFooter'
import { Color } from '../../../Common/Color'
import ComputerPublicHeader from '../Header/Computer/ComputerPublicHeader'

export default function ComputerCompleteLayout () {
  return (
    <Layout>
      <ComputerPublicHeader withSearch={true} />
      <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
        <Outlet />
      </Layout.Content>
      <PublicFooter />
    </Layout>
  )
}
